import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import BlankState from '../../../components/BlankState';
import DataTable from '../../../components/DataTable';
import Page from '../../../components/Page';


import { fetchPayments } from '../../../actions/payments';

import { DateRange, getDateRange } from '../../../components/DateRange';

class ReceivedPayments extends Component{

	constructor(props){
		super(props);

		this.state = {
            active_payment: {},
            filter: {
                payment_method: '',
                start_date: '',
                end_date: '',
                insurer: '',
                payment_status: 'COMPLETED'
            }
        };
	}

	componentDidMount() {
		this.loadPayments();
    }
    
    loadPayments = () => {
        this.props.fetchPayments(this.state.filter);
    }

    onChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            filter: {
                ...this.state.filter,
                [name]: value
            }
        }, ()=>{

            this.loadPayments();
        })
    }

    onChangeDateRange = (e) => {
        let dateRange = getDateRange(e.target.value);

        this.setState({
            ...this.state.filter,
            ...dateRange
        });

        this.loadPayments();
    }
	
	render(){
        const { payments } = this.props;

		return(
			<Page isAdminPage={ true } pageTitle="Received Payments">
				<div className="clearfix">
					<div className="card">
                        <div className="filter-form form-inline clearfix">
                            <div className="btn-group">
                                <label className="btn-radio">
                                    <input type="radio" name="payment_method" value=""
                                        onChange={ this.onChange } defaultChecked />
                                    <span>ALL</span>
                                </label>
                                <label className="btn-radio">
                                    <input type="radio" name="payment_method" value="MPESA"
                                        onChange={ this.onChange } />
                                    <span>MPESA</span>
                                </label>
                                <label className="btn-radio">
                                    <input type="radio" name="payment_method" value="CREDITCARD_ACP_KE"
                                        onChange={ this.onChange } />
                                    <span>VISA / MASTERCARD</span>
                                </label>
                                <label className="btn-radio">
                                    <input type="radio" name="payment_method" value="PESAPAL"
                                        onChange={ this.onChange } />
                                    <span>PESAPAL WALLET</span>
                                </label>
                                
                                <DateRange ref="dateRange" onChange={ this.onChangeDateRange } />
                            </div>
                        </div>

                        <hr/>
                        
                        {
                            payments.payments.length > 0 && !payments.payments_loading ?

                            <DataTable 
                                tableId={ 'payments-table' }
                                columnTitles={ 
                                    ["Transaction ID", "Payment Method", "Payment Reference", "Date Paid",  "Payment Status"] 
                                }>
                            
                            {
                                payments.payments.map((payment, index)=>{
                                    const { 
                                        transaction_id, payment_method, payment_reference, updated_on, payment_status 
                                    } = payment;

                                    return(
                                        <tr key={ index } >
                                            <td>{ transaction_id }</td>
                                            <td>{ payment_method }</td>
                                            <td>{ payment_reference }</td>
                                            <td>{ moment(updated_on).format('MMM Do, YYYY') }</td>
                                            <td>
                                                <span className="label label-success">{ payment_status }</span>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </DataTable>
                        :
                            <BlankState 
                                data={ payments.payments } 
                                dataName="Payments" 
                                isDataLoading={ payments.payments_loading } />
                        }
					</div>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	user: state.user,
	payments: state.payments
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ fetchPayments }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceivedPayments);


// WEBPACK FOOTER //
// ./src/pages/dashboard/payments/ReceivedPayments.jsx